import * as React from 'react';
import { AutocompleteInput, useNotify, useRecordContext } from 'react-admin';
import { useController } from 'react-hook-form';
import { goApi } from '../../../services';

type LocationItem = {
    key: string;
    value: string;
};

export const LocationsAutoComplete = (props: any) => {
    const { field } = useController({ name: props.source });
    const record = useRecordContext<any>();
    const notify = useNotify();

    const organizationId = record?.organizationId;

    const [choices, setChoices] = React.useState<LocationItem[]>([]);
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        const fetchLocations = async () => {
            try {
                setLoading(true);
                const response = await goApi.get<any>(
                    `/locations`
                );
                setChoices(response?.data?.items || []);
            } catch (error) {
                notify('Failed to load locations', { type: 'error' });
            } finally {
                setLoading(false);
            }
        };

        fetchLocations();
    }, [organizationId, notify]);

    return (
        <AutocompleteInput
            {...props}
            {...field}
            source={props.source || 'location'}
            label={props.label || 'Location'}
            choices={choices}
            optionText="key"
            optionValue="value"
            loading={loading}
            fullWidth
        />
    );
};
